import React, { useState, useEffect } from 'react';
import "../css/Events.css";
import { Icon, Grid } from 'semantic-ui-react';

let commentMap;

export default function EventComment({ eventid }) {
    const [comments, setComments] = useState();

    useEffect(() => {
        getComments();
    }, []);
    
    return (
        <div>
            {comments}
        </div>
    )

    function ratingStars(ratingNumber) {
        if (ratingNumber === 0) {
            return (
                <div className='events-stars'>
                    <Icon name='star outline' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                </div>
            );
        }
        else if (ratingNumber === 1) {
            return (
                <div className='events-stars'>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                </div>
            );
        }
        else if (ratingNumber === 2) {
            return (
                <div className='events-stars'>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                </div>
            );
        }
        else if (ratingNumber === 3) {
            return (
                <div className='events-stars'>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                </div>
            );
        }
        else if (ratingNumber === 4) {
            return (
                <div className='events-stars'>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star outline' className='events-event-icon'/>
                </div>
            );
        }
        else if (ratingNumber === 5) {
            return (
                <div className='events-stars'>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star' className='events-event-icon'/>
                    <Icon name='star' className='events-event-icon'/>
                </div>
            );
        }
    }

    async function mapComments(commentsList) {
        commentMap = commentsList.map((comment, idx) => {
            return (
                <div className='comment' key={idx}>
                    <Grid columns={2}>
                        <Grid.Column>
                            <h3 className='events-comment-header'>{comment.firstname} {comment.lastname}</h3>
                        </Grid.Column>
                        <Grid.Column className='events-comment-header-right'>
                            {/* <h3 className='events-comment-header'>{comment.dateCreated}</h3> */}
                        </Grid.Column>
                    </Grid>
                    <div className='events-comment'>
                        <div className='events-comment-rating'>
                            {ratingStars(comment.rating)}
                        </div>
                        <p className='events-comment-text'>{comment.comment}</p>
                    </div>
                </div>
            );
        });

        setComments(commentMap);
    }

    async function getComments() {
        // console.log("eventid ", eventid);
        try {
            let info = {
                eventid: eventid
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listComments.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error !== "") {
                console.log(res.error);
            }
            else {
                console.log("Comments:", res.results);
                mapComments(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }
}

